import React from "react";
import { useIntl } from "react-intl";

import { ColumnProps } from "src/common/components/DataTable";
import { messages } from "src/views/user-list/messages";
import { UserState } from "src/views/user-list/UserState";

export function useUserListColumns({
	activateUser,
	deactivateUser
}: {
	activateUser(id: string): unknown;
	deactivateUser(id: string): unknown;
}): ColumnProps[] {
	const { formatMessage } = useIntl();
	return React.useMemo(
		() => [
			{ key: "name", label: formatMessage(messages.name) },
			{ key: "email", label: formatMessage(messages.email) },
			{
				key: "inactive",
				label: formatMessage(messages.state),
				render: (
					_: unknown,
					{ id, inactive }: { id: string; inactive: boolean }
				) => (
					<UserState
						id={id}
						inactive={inactive}
						activateUser={activateUser}
						deactivateUser={deactivateUser}
					/>
				),
				mapToString(inactive: boolean) {
					return inactive
						? formatMessage(messages.inactive)
						: formatMessage(messages.active);
				}
			}
		],
		[formatMessage, activateUser, deactivateUser]
	);
}
